// src/hooks/useSession.js
import { useState, useCallback } from 'react';
import { fetchMessages, persistMessage } from '../api/ai';

export function useSession() {
  const [sessionId, setSessionId] = useState(
    () => crypto.randomUUID ? crypto.randomUUID() : `session-${Date.now()}`
  );
  const [sessionFull, setSessionFull] = useState(false);

  const startNewSession = useCallback(() => {
    const newId = crypto.randomUUID ? crypto.randomUUID() : `session-${Date.now()}`;
    setSessionId(newId);
    setSessionFull(false);
    return newId;
  }, []);

  const loadSessionMessages = useCallback(async (sid) => {
    try {
      const data = await fetchMessages(sid);
      return (Array.isArray(data) ? data : []).map(msg => ({
        id: msg.id,
        role: msg.role,
        content: msg.content,
        thinkingSteps: [],
        cards: null,
      }));
    } catch {
      return [];
    }
  }, []);

  const persist = useCallback(async (role, content) => {
    try {
      await persistMessage({ session_id: sessionId, role, content });
    } catch (e) {
      console.error('Persist error', e);
    }
  }, [sessionId]);

  return {
    sessionId,
    setSessionId,
    sessionFull,
    setSessionFull,
    startNewSession,
    loadSessionMessages,
    persistMessage: persist,
  };
}